export const START_WORKING_HOUR = 7
